import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withCtx as _withCtx, normalizeClass as _normalizeClass, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "section content-container" }
const _hoisted_2 = { class: "container is-fluid" }
const _hoisted_3 = { class: "columns" }
const _hoisted_4 = { class: "column" }
const _hoisted_5 = { class: "columns island-content" }
const _hoisted_6 = { class: "column" }
const _hoisted_7 = {
  key: 1,
  class: "no-apps"
}
const _hoisted_8 = {
  key: 2,
  class: "table is-fullwidth"
}
const _hoisted_9 = { class: "app-icon channel-icon-svg" }
const _hoisted_10 = ["xlink:href"]
const _hoisted_11 = { class: "section content-container" }
const _hoisted_12 = { class: "container is-fluid" }
const _hoisted_13 = { class: "columns" }
const _hoisted_14 = { class: "column" }
const _hoisted_15 = { class: "columns island-content" }
const _hoisted_16 = {
  key: 1,
  class: "no-apps"
}
const _hoisted_17 = {
  key: 2,
  class: "table is-fullwidth"
}
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { key: 2 }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { key: 1 }
const _hoisted_23 = { key: 2 }
const _hoisted_24 = { class: "section content-container" }
const _hoisted_25 = { class: "container is-fluid" }
const _hoisted_26 = { class: "columns" }
const _hoisted_27 = { class: "column" }
const _hoisted_28 = { class: "columns island-content" }
const _hoisted_29 = { class: "save-bot column" }

import TitledSection from '@shared/components/TitledSection.vue';
import { computed, onMounted, ref } from 'vue';
import WorkspaceViewModel from '@/workspaces/models/workspaceViewModel';
import { useRoute } from 'vue-router';
import FeatureFlagViewModel from '@/workspaces/models/featureFlagViewModel';
import { workspacesApi } from '@/workspaces/workspaces';
import Toast from '@shared/services/toast';
import { appsApi } from '@/features/apps/shared/services/apps';
import { PrivateApp, PublishedApp } from '@/features/apps/shared/models';
import NoDataIcon from '@/shared/icons/InsertChartOutlined.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'EditWorkspace',
  setup(__props) {

const route = useRoute();
const workspaceId = computed(() => <string>route.params.id);
const publishedApps = ref<PublishedApp[]>();
const privateApps = ref<PrivateApp[]>();
const workspace = ref<WorkspaceViewModel>();
const featureFlags = ref<FeatureFlagViewModel[]>([]);
const updateInProgress = ref(false);

const featuresLoaded = computed(() => !!workspace.value && featureFlags.value.length > 0);
const publishedAppsLoaded = computed(() => publishedApps.value !== undefined);
const privateAppsLoaded = computed(() => privateApps.value !== undefined);

onMounted(async () => {
  publishedApps.value = await appsApi.listPublished(workspaceId.value);
  publishedApps.value = publishedApps.value.filter((a: PublishedApp) => a.isInstalled);
  privateApps.value = await appsApi.listPrivate(workspaceId.value);
  workspace.value = await workspacesApi.getById(workspaceId.value);
  featureFlags.value = await workspacesApi.getFeatureFlags();

  workspace.value.features ??= [];
  for (const feature of featureFlags.value) {
    if (workspace.value.features[feature.id] === undefined) {
      workspace.value.features[feature.id] = feature.defaultValue;
    }
  }
});

function getStatus(capabilityEnabled: boolean): string {
  return capabilityEnabled ? 'Enabled' : 'Disabled';
}

function getStatusClass(capabilityEnabled: boolean): string {
  return capabilityEnabled ? 'is-success' : 'is-danger';
}

function hasActionUrls(app: PrivateApp) {
  return !!app.workflowOptions?.configUrl || !!app.workflowOptions?.initUrl || !!app.workflowOptions?.submitUrl;
}

function getAppActionUrls(app: PrivateApp) {
  const values: string[] = [];
  if (app.workflowOptions?.configUrl) {
    values.push(`Config Url: ${app.workflowOptions.configUrl}`);
  }
  if (app.workflowOptions?.initUrl) {
    values.push(`Init Url: ${app.workflowOptions.initUrl}`);
  }
  if (app.workflowOptions?.submitUrl) {
    values.push(`Submit Url: ${app.workflowOptions.submitUrl}`);
  }
  return values.join('\n');
}

async function updateFeatures() {
  updateInProgress.value = true;
  try {
    workspace.value = await workspacesApi.update(workspaceId.value, workspace.value);
    Toast.showSuccess('Updated workspace features.');
  } catch (err: any) {
    Toast.showError(`Failed to update features. ${err?.message || err}`);
  } finally {
    updateInProgress.value = false;
  }
}

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_n_loading_spinner = _resolveComponent("n-loading-spinner")!
  const _component_n_tooltip = _resolveComponent("n-tooltip")!
  const _component_n_toggle = _resolveComponent("n-toggle")!
  const _component_n_button = _resolveComponent("n-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(TitledSection, { class: "container island is-fluid" }, {
              icon: _withCtx(() => [
                _createVNode(_component_font_awesome_icon, { icon: "cubes" })
              ]),
              title: _withCtx(() => _cache[1] || (_cache[1] = [
                _createTextVNode("Public Apps")
              ])),
              subtitle: _withCtx(() => _cache[2] || (_cache[2] = [
                _createTextVNode(" Apps that have been installed for this workspace.")
              ])),
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    (!publishedAppsLoaded.value)
                      ? (_openBlock(), _createBlock(_component_n_loading_spinner, {
                          key: 0,
                          style: {"margin":"4rem auto"}
                        }))
                      : (publishedApps.value.length === 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                            _createVNode(NoDataIcon, { class: "no-apps-icon" }),
                            _cache[3] || (_cache[3] = _createElementVNode("div", { class: "no-apps-text" }, "No public apps installed", -1))
                          ]))
                        : (_openBlock(), _createElementBlock("table", _hoisted_8, [
                            _cache[4] || (_cache[4] = _createElementVNode("thead", null, [
                              _createElementVNode("tr", null, [
                                _createElementVNode("th", { style: {"width":"40px"} }, " "),
                                _createElementVNode("th", null, "Name")
                              ])
                            ], -1)),
                            _createElementVNode("tbody", null, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(publishedApps.value, (app) => {
                                return (_openBlock(), _createElementBlock("tr", {
                                  key: app.id
                                }, [
                                  _createElementVNode("td", null, [
                                    (_openBlock(), _createElementBlock("svg", _hoisted_9, [
                                      _createElementVNode("use", {
                                        "xmlns:xlink": "http://www.w3.org/1999/xlink",
                                        "xlink:href": `#${app.icon === 'webassistant' ? 'web-assistant' : app.icon}`
                                      }, null, 8, _hoisted_10)
                                    ]))
                                  ]),
                                  _createElementVNode("td", null, _toDisplayString(app.name), 1)
                                ]))
                              }), 128))
                            ])
                          ]))
                  ])
                ])
              ]),
              _: 1
            })
          ])
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createVNode(TitledSection, { class: "container island is-fluid" }, {
              icon: _withCtx(() => [
                _createVNode(_component_font_awesome_icon, { icon: "code" })
              ]),
              title: _withCtx(() => _cache[5] || (_cache[5] = [
                _createTextVNode("Private Apps")
              ])),
              subtitle: _withCtx(() => _cache[6] || (_cache[6] = [
                _createTextVNode(" Custom apps configured in there workspaces. ")
              ])),
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_15, [
                  (!privateAppsLoaded.value)
                    ? (_openBlock(), _createBlock(_component_n_loading_spinner, {
                        key: 0,
                        style: {"margin":"4rem auto"}
                      }))
                    : (privateApps.value.length === 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                          _createVNode(NoDataIcon, { class: "no-apps-icon" }),
                          _cache[7] || (_cache[7] = _createElementVNode("div", { class: "no-apps-text" }, "No private apps configured", -1))
                        ]))
                      : (_openBlock(), _createElementBlock("table", _hoisted_17, [
                          _cache[22] || (_cache[22] = _createElementVNode("thead", null, [
                            _createElementVNode("tr", null, [
                              _createElementVNode("th", null, "Name"),
                              _createElementVNode("th", null, "Supports bot action"),
                              _createElementVNode("th", null, "Supports homescreen"),
                              _createElementVNode("th", null, "Supports webhooks")
                            ])
                          ], -1)),
                          _createElementVNode("tbody", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(privateApps.value, (app) => {
                              return (_openBlock(), _createElementBlock("tr", {
                                key: app.id
                              }, [
                                _createElementVNode("td", null, _toDisplayString(app.name), 1),
                                _createElementVNode("td", null, [
                                  _createVNode(_component_n_tooltip, { wide: "" }, _createSlots({
                                    default: _withCtx(() => [
                                      _createElementVNode("span", {
                                        class: _normalizeClass(["tag", getStatusClass(app.capabilities?.supportsHomescreen)])
                                      }, _toDisplayString(getStatus(app.capabilities?.supportsHomescreen)), 3)
                                    ]),
                                    _: 2
                                  }, [
                                    (hasActionUrls(app))
                                      ? {
                                          name: "message",
                                          fn: _withCtx(() => [
                                            _createElementVNode("table", null, [
                                              (app.workflowOptions.configUrl)
                                                ? (_openBlock(), _createElementBlock("tr", _hoisted_18, [
                                                    _cache[8] || (_cache[8] = _createElementVNode("td", null, [
                                                      _createElementVNode("b", null, "Config Url:")
                                                    ], -1)),
                                                    _cache[9] || (_cache[9] = _createElementVNode("td", null, "    ", -1)),
                                                    _createElementVNode("td", null, _toDisplayString(app.workflowOptions.configUrl), 1)
                                                  ]))
                                                : _createCommentVNode("", true),
                                              (app.workflowOptions.initUrl)
                                                ? (_openBlock(), _createElementBlock("tr", _hoisted_19, [
                                                    _cache[10] || (_cache[10] = _createElementVNode("td", null, [
                                                      _createElementVNode("b", null, "Init Url:")
                                                    ], -1)),
                                                    _cache[11] || (_cache[11] = _createElementVNode("td", null, "    ", -1)),
                                                    _createElementVNode("td", null, _toDisplayString(app.workflowOptions.initUrl), 1)
                                                  ]))
                                                : _createCommentVNode("", true),
                                              (app.workflowOptions.submitUrl)
                                                ? (_openBlock(), _createElementBlock("tr", _hoisted_20, [
                                                    _cache[12] || (_cache[12] = _createElementVNode("td", null, [
                                                      _createElementVNode("b", null, "Submit Url:")
                                                    ], -1)),
                                                    _cache[13] || (_cache[13] = _createElementVNode("td", null, "    ", -1)),
                                                    _createElementVNode("td", null, _toDisplayString(app.workflowOptions.submitUrl), 1)
                                                  ]))
                                                : _createCommentVNode("", true)
                                            ])
                                          ]),
                                          key: "0"
                                        }
                                      : undefined
                                  ]), 1024)
                                ]),
                                _createElementVNode("td", null, [
                                  _createVNode(_component_n_tooltip, { wide: "" }, _createSlots({
                                    default: _withCtx(() => [
                                      _createElementVNode("span", {
                                        class: _normalizeClass(["tag", getStatusClass(app.capabilities?.supportsBotAction)])
                                      }, _toDisplayString(getStatus(app.capabilities?.supportsBotAction)), 3)
                                    ]),
                                    _: 2
                                  }, [
                                    (hasActionUrls(app))
                                      ? {
                                          name: "message",
                                          fn: _withCtx(() => [
                                            _createElementVNode("table", null, [
                                              (app.workflowOptions.configUrl)
                                                ? (_openBlock(), _createElementBlock("tr", _hoisted_21, [
                                                    _cache[14] || (_cache[14] = _createElementVNode("td", null, [
                                                      _createElementVNode("b", null, "Config Url:")
                                                    ], -1)),
                                                    _cache[15] || (_cache[15] = _createElementVNode("td", null, "    ", -1)),
                                                    _createElementVNode("td", null, _toDisplayString(app.workflowOptions.configUrl), 1)
                                                  ]))
                                                : _createCommentVNode("", true),
                                              (app.workflowOptions.initUrl)
                                                ? (_openBlock(), _createElementBlock("tr", _hoisted_22, [
                                                    _cache[16] || (_cache[16] = _createElementVNode("td", null, [
                                                      _createElementVNode("b", null, "Init Url:")
                                                    ], -1)),
                                                    _cache[17] || (_cache[17] = _createElementVNode("td", null, "    ", -1)),
                                                    _createElementVNode("td", null, _toDisplayString(app.workflowOptions.initUrl), 1)
                                                  ]))
                                                : _createCommentVNode("", true),
                                              (app.workflowOptions.submitUrl)
                                                ? (_openBlock(), _createElementBlock("tr", _hoisted_23, [
                                                    _cache[18] || (_cache[18] = _createElementVNode("td", null, [
                                                      _createElementVNode("b", null, "Submit Url:")
                                                    ], -1)),
                                                    _cache[19] || (_cache[19] = _createElementVNode("td", null, "    ", -1)),
                                                    _createElementVNode("td", null, _toDisplayString(app.workflowOptions.submitUrl), 1)
                                                  ]))
                                                : _createCommentVNode("", true)
                                            ])
                                          ]),
                                          key: "0"
                                        }
                                      : undefined
                                  ]), 1024)
                                ]),
                                _createElementVNode("td", null, [
                                  _createVNode(_component_n_tooltip, { wide: "" }, _createSlots({
                                    default: _withCtx(() => [
                                      _createElementVNode("span", {
                                        class: _normalizeClass(["tag", getStatusClass(app.capabilities?.supportsWebhooks)])
                                      }, _toDisplayString(getStatus(app.capabilities?.supportsWebhooks)), 3)
                                    ]),
                                    _: 2
                                  }, [
                                    (app.workflowOptions?.webhookUrl)
                                      ? {
                                          name: "message",
                                          fn: _withCtx(() => [
                                            _createElementVNode("table", null, [
                                              _createElementVNode("tr", null, [
                                                _cache[20] || (_cache[20] = _createElementVNode("td", null, [
                                                  _createElementVNode("b", null, "Webhook Url:")
                                                ], -1)),
                                                _cache[21] || (_cache[21] = _createElementVNode("td", null, "    ", -1)),
                                                _createElementVNode("td", null, _toDisplayString(app.workflowOptions.webhookUrl), 1)
                                              ])
                                            ])
                                          ]),
                                          key: "0"
                                        }
                                      : undefined
                                  ]), 1024)
                                ])
                              ]))
                            }), 128))
                          ])
                        ]))
                ])
              ]),
              _: 1
            })
          ])
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_24, [
      _createElementVNode("div", _hoisted_25, [
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("div", _hoisted_27, [
            _createVNode(TitledSection, { class: "container island is-fluid" }, {
              icon: _withCtx(() => [
                _createVNode(_component_font_awesome_icon, { icon: "cog" })
              ]),
              title: _withCtx(() => _cache[23] || (_cache[23] = [
                _createTextVNode("Features")
              ])),
              subtitle: _withCtx(() => _cache[24] || (_cache[24] = [
                _createTextVNode(" Licensed features currently set and editable. ")
              ])),
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_28, [
                  (!featuresLoaded.value)
                    ? (_openBlock(), _createBlock(_component_n_loading_spinner, {
                        key: 0,
                        style: {"margin":"4rem auto"}
                      }))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(featureFlags.value, (feature) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "feature-selector__list-item",
                            key: feature.id
                          }, [
                            _createVNode(_component_n_toggle, {
                              id: `toggle-${feature.id}`,
                              modelValue: workspace.value.features[feature.id],
                              "onUpdate:modelValue": ($event: any) => ((workspace.value.features[feature.id]) = $event),
                              label: feature.displayName
                            }, null, 8, ["id", "modelValue", "onUpdate:modelValue", "label"])
                          ]))
                        }), 128)),
                        _createElementVNode("div", _hoisted_29, [
                          _createVNode(_component_n_button, {
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (updateFeatures())),
                            variant: "primary",
                            class: "save-button",
                            loading: updateInProgress.value
                          }, {
                            default: _withCtx(() => _cache[25] || (_cache[25] = [
                              _createTextVNode(" Update ")
                            ])),
                            _: 1
                          }, 8, ["loading"])
                        ])
                      ], 64))
                ])
              ]),
              _: 1
            })
          ])
        ])
      ])
    ])
  ], 64))
}
}

})